import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genInputStyle = function genInputStyle(token) {
  var _$concat$concat, _single, _$concat$concat2, _$concat2, _$concat3;

  var componentCls = token.componentCls,
      antCls = token.antCls,
      fontSizeSM = token.fontSizeSM,
      lineHeightSM = token.lineHeightSM,
      colorPickerAlphaInputWidth = token.colorPickerAlphaInputWidth,
      marginXXS = token.marginXXS,
      paddingXXS = token.paddingXXS,
      controlHeightSM = token.controlHeightSM,
      marginXS = token.marginXS,
      fontSizeIcon = token.fontSizeIcon,
      paddingXS = token.paddingXS,
      colorTextPlaceholder = token.colorTextPlaceholder,
      colorPickerInputNumberHandleWidth = token.colorPickerInputNumberHandleWidth,
      lineWidth = token.lineWidth;
  return _defineProperty({}, "".concat(componentCls, "-input-container"), (_$concat3 = {
    display: 'flex'
  }, _defineProperty(_$concat3, "".concat(componentCls, "-steppers").concat(antCls, "-input-number"), (_$concat$concat = {
    fontSize: fontSizeSM,
    lineHeight: lineHeightSM
  }, _defineProperty(_$concat$concat, "".concat(antCls, "-input-number-input"), {
    paddingInlineStart: paddingXXS,
    paddingInlineEnd: 0
  }), _defineProperty(_$concat$concat, "".concat(antCls, "-input-number-handler-wrap"), {
    width: colorPickerInputNumberHandleWidth
  }), _$concat$concat)), _defineProperty(_$concat3, "".concat(componentCls, "-steppers").concat(componentCls, "-alpha-input"), {
    flex: "0 0 ".concat(colorPickerAlphaInputWidth, "px"),
    marginInlineStart: marginXXS
  }), _defineProperty(_$concat3, "".concat(componentCls, "-format-select").concat(antCls, "-select"), {
    marginInlineEnd: marginXS,
    width: 'auto',
    '&-single': (_single = {}, _defineProperty(_single, "".concat(antCls, "-select-selector"), {
      padding: 0,
      border: 0
    }), _defineProperty(_single, "".concat(antCls, "-select-arrow"), {
      insetInlineEnd: 0
    }), _defineProperty(_single, "".concat(antCls, "-select-selection-item"), {
      paddingInlineEnd: fontSizeIcon + marginXXS,
      fontSize: fontSizeSM,
      lineHeight: "".concat(controlHeightSM, "px")
    }), _defineProperty(_single, "".concat(antCls, "-select-item-option-content"), {
      fontSize: fontSizeSM,
      lineHeight: lineHeightSM
    }), _defineProperty(_single, "".concat(antCls, "-select-dropdown"), _defineProperty({}, "".concat(antCls, "-select-item"), {
      minHeight: 'auto'
    })), _single)
  }), _defineProperty(_$concat3, "".concat(componentCls, "-input"), (_$concat2 = {
    gap: marginXXS,
    alignItems: 'center',
    flex: 1,
    width: 0
  }, _defineProperty(_$concat2, "".concat(componentCls, "-hsb-input,").concat(componentCls, "-rgb-input"), {
    display: 'flex',
    gap: marginXXS,
    alignItems: 'center'
  }), _defineProperty(_$concat2, "".concat(componentCls, "-steppers"), {
    flex: 1
  }), _defineProperty(_$concat2, "".concat(componentCls, "-hex-input").concat(antCls, "-input-affix-wrapper"), (_$concat$concat2 = {
    flex: 1,
    padding: "0 ".concat(paddingXS, "px")
  }, _defineProperty(_$concat$concat2, "".concat(antCls, "-input"), {
    fontSize: fontSizeSM,
    lineHeight: "".concat(controlHeightSM - 2 * lineWidth, "px")
  }), _defineProperty(_$concat$concat2, "".concat(antCls, "-input-prefix"), {
    color: colorTextPlaceholder
  }), _$concat$concat2)), _$concat2)), _$concat3));
};

export default genInputStyle;